import * as React from 'react';

import { QueryBuilderModel } from 'bones/components/molecules/QueryBuilder/types/model';

export const QueryBuilderModelContext = React.createContext<QueryBuilderModel>({
  classesByIri: {},
  propertiesByIri: {},
});

export const useQueryBuilderModelContext = () => {
  const model = React.useContext(QueryBuilderModelContext);
  return model;
};
